import React, { useEffect, useState } from "react";
import api from "../lib/api";
import LiveMap from "./LiveMap";

const STATUS_COLOR = { in_consegna: "#22D3EE", disponibile: "#00E676", offline: "#6b7280" };

// Mappa live con TUTTI i rider (per Centrale operativa e CEO). I pin si muovono
// in modo fluido grazie all'animazione integrata in LiveMap.
export default function RidersLiveMap({ height = 460 }) {
  const [riders, setRiders] = useState([]);
  useEffect(() => {
    const load = async () => { try { const { data } = await api.get("/riders/live"); setRiders(data || []); } catch {} };
    load(); const t = setInterval(load, 6000); return () => clearInterval(t);
  }, []);

  const points = riders
    .filter((r) => r.location && typeof r.location.lat === "number")
    .map((r) => ({ id: r.id, lat: r.location.lat, lng: r.location.lng, label: r.name.split(" ")[0], type: "rider", color: STATUS_COLOR[r.status] || "#00E676" }));
  const online = riders.filter((r) => r.status !== "offline").length;

  return (
    <div className="space-y-4" data-testid="riders-live-map">
      <div className="flex gap-4 text-sm flex-wrap" data-testid="riders-legend">
        <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-[#22D3EE]" /> In consegna</span>
        <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-[#00E676]" /> Disponibile</span>
        <span className="flex items-center gap-1"><span className="h-3 w-3 rounded-full bg-zinc-500" /> Offline</span>
      </div>
      <LiveMap height={height} points={points} />
      <div className="text-zinc-400 text-sm" data-testid="riders-map-summary">{points.length} rider con posizione GPS · {online} rider online.</div>
      {points.length === 0 && <div className="text-xs text-zinc-500">Nessun rider sta condividendo la posizione GPS in questo momento.</div>}
    </div>
  );
}
